import { u as useClientOnly } from "./useClientOnly-c9844a99.mjs";
const useWindow = () => useClientOnly(() => window);
export {
  useWindow as u
};
//# sourceMappingURL=useWindow-549880c7.mjs.map
